// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"27f63ec6","348":"3dacb821","578":"894b1f89","737":"7eec9d12","940":"d5f66025"}[chunkId] + ".chunk.js";
};